export function debounce<TArgs extends unknown[]>(
  this: unknown,
  fn: (...args: TArgs) => void,
  wait = 0,
  options: { inmediate?: boolean } = {},
): (...args: TArgs) => void {
  let timeout: ReturnType<typeof setTimeout> | undefined

  return (...args: TArgs) => {
    const inmediate =
      'inmediate' in options ? !!options.inmediate : options.inmediate
    const later = () => {
      timeout = undefined
      if (!inmediate) fn.apply(this, args)
    }
    const now = inmediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (now) fn.apply(this, args)
  }
}
